import useMediaQuery from "@mui/material/useMediaQuery";
import { EditableText } from "@smartfire/components";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

export const LastTile = ({ catSelected, urlCircleLogoWhite }) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery("(min-width:" + style.mobileBreakpoint + ")");

  return (
    <a href={catSelected?.link} className={style.lastTile}>
      <div className={style.text}>
        <EditableText
          placeholder={`${t("Need more inspiration")}?`}
          smartProp="lastTileTitle"
          className={style.titleLastTile}
        />

        <EditableText
          tagName="p"
          placeholder={`${t("Find all trends")}…`}
          smartProp="lastTileText"
          className={style.titleLastText}
        />
      </div>

      <div className={style.icon}>
        {isDesktop && urlCircleLogoWhite && (
          <img
            src={urlCircleLogoWhite}
            alt=""
            className={style.circleLogoWhite}
            loading="lazy"
            aria-hidden="true"
          />
        )}

        <div className={style.arrowContainer}>
          <div className={style.arrow}></div>
        </div>
      </div>

      <div className={style.mask}></div>
    </a>
  );
};

export default LastTile;
